const get = async () => {
  const q = await fetch("/api/user_eligibility");
  return q.json();
}

export default {
  get
}
